import { render, staticRenderFns } from "./rule7.vue?vue&type=template&id=35939243&scoped=true"
import script from "./rule7.vue?vue&type=script&lang=js"
export * from "./rule7.vue?vue&type=script&lang=js"
import style0 from "./rule7.vue?vue&type=style&index=0&id=35939243&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35939243",
  null
  
)

export default component.exports